import { useEffect } from "react";
import * as Router from "next/router";

// Redirect to new page - kept in case links exist in any external / marketing materials
const Privacy = () => {
  const router = Router.useRouter();

  useEffect(() => {
    router.push({
      pathname: "/policies",
      query: { slug: "privacy" },
    });
  }, [router.query]);

  return null;
};

export default Privacy;
